export const ProgressOrCompletion = {
  question: "What's the difference between progress and completion measures?",
  answer: `
* **Progress measures**: Setting a target number or percentage, for example “Achieve a 75% open rate for customer email campaigns by the end of Q2.”
* **Completion Measures**: Setting a goal of whether or not a particular activity is completed, such as “Launch a blog for internal communications by the end of Q4.”
`
}